import { SupplyGrouping } from '@components/Admin/Location/Cards/components/CreateCard/TerminalSelection/SupplyGrouping'
import { GraviGrid, Horizontal, Texto } from '@gravitate-js/excalibrr'

import { SearchOutlined } from '@ant-design/icons'
import { useTerminalCards } from '@api/useTerminalCards'
import { useSelectedTerminalContext } from '@components/Admin/Location/Cards/components/CreateCard/TerminalSelection/TerminalSelectionContext'
import type { AgGridReactProps } from 'ag-grid-react'
import { Checkbox, Input } from 'antd'
import React, { useCallback, useMemo, useRef } from 'react'
import { getColumnDefs } from './TerminalSelectectionColDefs'

export const TerminalSelection = ({}) => {
  const { setSelectedTerminals } = useSelectedTerminalContext()

  const gridAPIRef = useRef(null)
  const { getCardsMetadataQuery } = useTerminalCards()
  const { data, isFetching } = getCardsMetadataQuery()
  const getRowId = useCallback((row) => row?.data?.terminal_id, [])
  const columnDefs = useMemo(() => getColumnDefs(), [])
  const agPropOverrides = useMemo(() => {
    return {
      getRowId,
      rowSelection: 'multiple',
      groupDefaultExpanded: -1,
      groupSelectsChildren: true,
      groupSelectsFiltered: true,
      suppressRowClickSelection: true,
      suppressCellFocus: true,
      rowGroupPanelShow: 'never',
      groupRowRenderer: 'agGroupRowRenderer',
      groupRowRendererParams: {
        innerRenderer: SupplyGrouping,
      },
    } as Partial<AgGridReactProps>
  }, [getRowId])

  return (
    <>
      <Horizontal className={'terminal-selection-control-bar p-2 bordered'}>
        <Texto>
          <b>Select ALL</b> Terminals that require this card
        </Texto>
      </Horizontal>
      <Horizontal
        className='p-2 border-right border-left'
        verticalCenter
        justifyContent={'space-between'}
        style={{ borderRadius: 0 }}
      >
        <Horizontal verticalCenter flex={1} className={'pr-2'}>
          <Checkbox
            className={'mx-2 terminal-selection'}
            onChange={(e) => (e.target.checked ? gridAPIRef.current.selectAll() : gridAPIRef.current.deselectAll())}
          />
          <Texto category='h4'>Terminals</Texto>
          <Texto category='h6' appearance='secondary' className={'mx-2'}>
            {data?.length} Results
          </Texto>
        </Horizontal>
        <Horizontal verticalCenter flex={1}>
          <Input
            prefix={<SearchOutlined className='pr-2' style={{ color: 'var(--gray-500)' }} />}
            placeholder='Search here'
            onChange={(e) => gridAPIRef.current.setQuickFilter(e.target.value)}
          />
        </Horizontal>
      </Horizontal>

      <GraviGrid
        // @ts-ignore - TODO: Add className to GraviGrid props list if it actually accepts it
        className='terminal-selection'
        loading={isFetching}
        externalRef={gridAPIRef}
        sideBar={null}
        enableRangeSelection={true}
        columnDefs={columnDefs}
        agPropOverrides={agPropOverrides}
        rowData={data || []}
        onSelectionChanged={(params) => setSelectedTerminals(params.api.getSelectedRows())}
        onRangeSelectionChanged={(params) => setSelectedTerminals(params.api.getSelectedRows())}
      />
    </>
  )
}
